// import React, { useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { signOut } from 'firebase/auth';
// import { auth } from '../firebase';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';

// const Sidebar = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const location = useLocation();

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//   };

//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       // Navigate to login is typically handled by an auth listener
//     } catch (error) {
//       console.error("Logout error:", error);
//     }
//   };

//   const menuItems = [
//     { title: 'Dashboard', icon: 'bi-speedometer2', path: '/' },
//     { title: 'Users', icon: 'bi-people', path: '/user' },
//     { title: 'Fines', icon: 'bi-currency-dollar', path: '/fines' },
//     { title: 'Reports', icon: 'bi-file-earmark-text', path: '/reports' },
//     { title: 'Settings', icon: 'bi-gear', path: '/settings' },
//   ];

//   return (
//     <div className={`sidebar ${collapsed ? 'collapsed' : ''}`} style={{
//       width: collapsed ? "80px" : "280px",
//       minHeight: "100vh",
//       background: "linear-gradient(180deg, #667eea 0%, #764ba2 100%)",
//       transition: "all 0.3s ease",
//       position: "fixed",
//       left: 0,
//       top: 0,
//       zIndex: 100,
//       boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)"
//     }}>
//       <div className="sidebar-header d-flex align-items-center justify-content-between p-3 mb-3">
//         {!collapsed && (
//           <h3 className="text-white fw-bold m-0">Fine System</h3>
//         )}
//         <button 
//           className="btn btn-link text-white border-0 p-0" 
//           onClick={toggleSidebar}
//           style={{ boxShadow: "none" }}
//         >
//           <i className={`bi ${collapsed ? 'bi-arrow-right-circle' : 'bi-arrow-left-circle'} fs-4`}></i>
//         </button>
//       </div>

//       <div className="sidebar-menu">
//         <ul className="nav flex-column">
//           {menuItems.map((item, index) => (
//             <li className="nav-item mb-2" key={index}>
//               <Link 
//                 to={item.path} 
//                 className={`nav-link py-3 px-3 ${location.pathname === item.path ? 'active' : ''}`}
//                 style={{
//                   color: "white",
//                   borderRadius: collapsed ? "0" : "0 30px 30px 0",
//                   marginRight: collapsed ? "0" : "10px",
//                   backgroundColor: location.pathname === item.path ? "rgba(255, 255, 255, 0.15)" : "transparent"
//                 }}
//               >
//                 <i className={`${item.icon} me-3 fs-5`}></i>
//                 {!collapsed && <span>{item.title}</span>}
//               </Link>
//             </li>
//           ))}
          
//           <li className="nav-item mt-auto">
//             <button 
//               onClick={handleLogout}
//               className="nav-link py-3 px-3 w-100 text-start"
//               style={{
//                 color: "white",
//                 border: "none",
//                 background: "transparent",
//                 borderRadius: collapsed ? "0" : "0 30px 30px 0",
//                 marginRight: collapsed ? "0" : "10px"
//               }}
//             >
//               <i className="bi bi-box-arrow-right me-3 fs-5"></i>
//               {!collapsed && <span>Logout</span>}
//             </button>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;



import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

import { auth } from '../firebase';
import { toast } from 'react-toastify';

// In Sidebar.js
import './sidenav.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();


  // Check if viewport is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener
    window.addEventListener('resize', checkIfMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Toggle sidebar collapse state
  const handleToggleCollapse = () => {
    if (!isMobile) {
      setCollapsed(!collapsed);
    }
  };

  // Handle the close button on mobile
  const handleCloseMobile = () => {
    if (isMobile && isOpen && toggleSidebar) {
      toggleSidebar();
    }
  };


  const handleLogout = async () => {
  try {
    await signOut(auth);
    navigate('/login'); // Redirect to login page after logout
    
// Inside handleLogout:
toast.success("Logged out successfully!");

  } catch (error) {
    console.error("Logout error:", error);
  }
};


  const menuItems = [
    { title: 'Dashboard', icon: 'bi-speedometer2', path: '/' },
    { title: 'Users', icon: 'bi-people', path: '/user' },
    { title: 'Fines', icon: 'bi-currency-dollar', path: '/fines' },
    { title: 'Events', icon: 'bi-file-earmark-text', path: '/events' },
    { title: 'Settings', icon: 'bi-gear', path: '/app-settings' },
  ];

  // Calculate actual sidebar width based on state and device
  const sidebarWidth = isMobile 
    ? (isOpen ? '250px' : '0') 
    : (collapsed ? '80px' : '250px');

  return (
    <div 
      className={`sidebar ${collapsed ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`} 
      style={{
        width: sidebarWidth,
        minHeight: "100vh",
        background: "linear-gradient(180deg, #667eea 0%, #764ba2 100%)",
        transition: "all 0.3s ease",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 1030,
        boxShadow: isOpen || !isMobile ? "0 0 20px rgba(0, 0, 0, 0.15)" : "none",
        overflowX: "hidden",
        overflowY: "auto"
      }}
    >
      <div className="sidebar-header d-flex align-items-center justify-content-between p-3 mb-3">
        {(!collapsed || isMobile) && (
          <h3 className="text-white fw-bold m-0 text-truncate">Fine System</h3>
        )}

        {isMobile ? (
          <button 
            className="btn btn-link text-white border-0 p-0" 
            onClick={handleCloseMobile}
            aria-label="Close Sidebar"
          >
            <i className="bi bi-x-lg fs-4"></i>
          </button>
        ) : (
          <button 
            className="btn btn-link text-white border-0 p-0" 
            onClick={handleToggleCollapse}
            aria-label={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
          >
            <i className={`bi ${collapsed ? 'bi-arrow-right-circle' : 'bi-arrow-left-circle'} fs-4`}></i>
          </button>
        )}
      </div>

      <div className="sidebar-menu">
        <ul className="nav flex-column">
          {menuItems.map((item, index) => (
            <li className="nav-item mb-2" key={index}>
              <Link 
                to={item.path} 
                className={`nav-link py-3 px-3 ${location.pathname === item.path ? 'active' : ''}`}
                style={{
                  color: "white",
                  borderRadius: (!isMobile && !collapsed) ? "0 30px 30px 0" : "0",
                  marginRight: (!isMobile && !collapsed) ? "10px" : "0",
                  backgroundColor: location.pathname === item.path ? "rgba(255, 255, 255, 0.15)" : "transparent",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
                onClick={isMobile ? handleCloseMobile : undefined}
              >
                <i className={`${item.icon} ${collapsed && !isMobile ? "" : "me-3"} fs-5`}></i>
                {(!collapsed || isMobile) && <span>{item.title}</span>}
              </Link>
            </li>
          ))}
        </ul>
        
        <div className="mt-4 mb-3 px-3">
          <button 
            onClick={handleLogout}
            className="btn btn-outline-light w-100 d-flex align-items-center justify-content-center py-2"
            style={{
              borderRadius: "8px",
              transition: "all 0.2s ease"
            }}
          >
            <i className="bi bi-box-arrow-right fs-5 me-2"></i>
            {(!collapsed || isMobile) && <span>Logout</span>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;